"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _types = require("../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var FormDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FormDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("form", _flowRuntime["default"].ref(FormDefinition)), _flowRuntime["default"].property("page", _flowRuntime["default"].number()), _flowRuntime["default"].property("setPage", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].number()), _flowRuntime["default"]["return"](_flowRuntime["default"].any())))));

var _default = function _default(_arg) {
  var form = _arg.form,
      page = _arg.page,
      setPage = _arg.setPage;
  return form.pages.length > 1 ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "Step ", page, " of ", form.pages.length), /*#__PURE__*/_react["default"].createElement("div", {
    className: "indicator-row"
  }, form.pages.map(function (p, i) {
    var className;

    if (i > page - 1) {
      className = 'page-complete';
    } else if (i < page - 1) {
      className = 'page-incomplete';
    } else {
      className = "page-completing page-".concat(i);
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      key: p.key
    }, /*#__PURE__*/_react["default"].createElement("button", {
      "aria-label": "step ".concat(i + 1),
      className: className,
      onClick: function onClick() {
        return setPage(i + 1);
      },
      type: "button"
    }));
  }))) : null;
};

exports["default"] = _default;